"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stripGraphql = exports.isWorker = exports.getTranslations = void 0;
var wixstores_client_core_1 = require("@wix/wixstores-client-core");
function getTranslations(path) {
    return fetch(path, {
        method: 'get',
    })
        .then(function (response) { return response.json(); })
        .catch(function (e) {
        throw new wixstores_client_core_1.FetchError('Could not fetch translation', { originalError: e.message, path: path });
    });
}
exports.getTranslations = getTranslations;
function isWorker() {
    /* istanbul ignore next: todo: test */
    return typeof WorkerGlobalScope !== 'undefined' && self instanceof WorkerGlobalScope;
}
exports.isWorker = isWorker;
function stripGraphql(query) {
    return (query
        //eslint-disable-next-line prefer-named-capture-group
        .replace(/(\r\n|\n|\r)/g, '')
        //eslint-disable-next-line prefer-named-capture-group
        .replace(/ +(?= )/g, '')
        .replace(/: /g, ':')
        .replace(/, \$/g, ',$')
        .replace(/\{ /g, '{')
        .replace(/ {/g, '{')
        .replace(/ }/g, '}')
        .replace(/} /g, '}')
        .replace(/, /g, ',')
        .replace(/ /g, ','));
}
exports.stripGraphql = stripGraphql;
//# sourceMappingURL=utils.js.map